import type { ReactNode } from "react";
import { ArticleList } from "./ArticleList";
import type { ArticleListData } from "./ArticleList.types";
import { MediaGallery } from "./MediaGallery";
import type { MediaGalleryData } from "./MediaGallery.types";
import { PatientCard } from "./PatientCard";
import type { PatientCardData } from "./PatientCard.types";

/** Renders a GenUI component from the raw props object carried on the stream event. */
export type GenUIRenderer = (props: Record<string, unknown>) => ReactNode;

/**
 * Maps a GenUI `component` name to its renderer. Each entry localizes the cast from the
 * untyped wire props to the component's typed props. Add new components here.
 */
export const genUIRegistry: Record<string, GenUIRenderer> = {
  render_patient_card: (props) => <PatientCard {...(props as unknown as PatientCardData)} />,
  render_media: (props) => <MediaGallery {...(props as unknown as MediaGalleryData)} />,
  render_article: (props) => <ArticleList {...(props as unknown as ArticleListData)} />,
};
